import * as React from 'react';
import { Button, Col, Form, FormFeedback, FormGroup, Input, Row } from 'reactstrap';
import { IUser } from 'src/model';
import { changePassword } from 'src/services';
import { isPassword } from 'src/utils/validation';

interface IProfileEditionProps {
  user: IUser;
}

export const PasswordEdition: React.SFC<IProfileEditionProps> = ({ user }) => {
  const [state, setState] = React.useState({
    confirmedPassword: '',
    currentPassword: '',
    invalid: false,
    isChanged: false, 
    newPassword: '',
  });
  const isValid =
    !!state.currentPassword &&
    isPassword(state.newPassword) &&
    state.newPassword === state.confirmedPassword &&
    state.newPassword !== state.currentPassword;

  const handleChange = (e: React.ChangeEvent<Element>) => {
    setState({
      ...state,
      invalid: false,
      [(e.target as any).name]: (e.target as any).value,
    });
  };

  const handleSave = async () => {
    const { currentPassword, newPassword } = state;
    if (isValid) {
      try {
        const updatedUser = await changePassword({
          currentPassword,
          newPassword,
        });
        if (updatedUser) {
          setState({
            confirmedPassword: '',
            currentPassword: '',
            invalid: false,
            isChanged: true,
            newPassword: '',
          });
        }
      } catch (error) {
        setState({ ...state, invalid: true });
      }
    } else {
      setState({ ...state, invalid: true });
    }
  };

  return (
    <Form className='p-5'>
      <Row>
        <Col md='12'>
          <span className='text-dark' style={{ fontSize: '32px' }}>
            Mot de passe
          </span>
          <p className='mt-3'>
          Votre mot de passe doit contenir 8 caractères minimum avec au moins une majuscule, un chiffre et un caractère spécial
          </p>
        </Col>
      </Row>
      <Row className='d-flex justify-content-between mt-2'>
        <Col md='5' xs='auto'>
          <FormGroup>
            <span className='d-block font-weight-bolder mb-2'>
              Mot de passe actuel
            </span>
            <Input
              type='password'
              name='currentPassword'
              disabled={state.isChanged}
              invalid={
                state.invalid &&
                (state.currentPassword === state.newPassword || isValid)
              }
              value={state.currentPassword}
              onChange={handleChange}
            />
            <FormFeedback>
              {state.currentPassword === state.newPassword
                ? 'Le nouveau mot de passe est identique au mot de passe actuel'
                : isValid
                ? 'Le mot de passe renseigné est incorrect'
                : null}
            </FormFeedback>
          </FormGroup>
          <FormGroup>
            <span className='d-block font-weight-bolder mb-2'>
              Nouveau mot de passe
            </span>
            <Input
              type='password'
              name='newPassword'
              disabled={state.isChanged}
              invalid={state.invalid && state.newPassword.length < 8}
              value={state.newPassword}
              onChange={handleChange}
            />
            <FormFeedback>
              Le nouveau mot de passe doit comporter 8 caractères minimum
            </FormFeedback>
          </FormGroup>
          <FormGroup>
            <span className='d-block font-weight-bolder mb-2'>
              Confirmer nouveau mot de passe
            </span>
            <Input
              type='password'
              name='confirmedPassword'
              disabled={state.isChanged}
              invalid={
                state.invalid && state.newPassword !== state.confirmedPassword
              }
              value={state.confirmedPassword}
              onChange={handleChange}
            />
            <FormFeedback>
              Les deux mots de passe ne correspondent pas
            </FormFeedback>
          </FormGroup>
        </Col>
      </Row>
      <Row className='mt-4'>
        {state.isChanged ? (
          <Col md='6'>
            <span className='text-success' style={{ fontSize: '20px' }}>
              Votre mot de passe a été modifié avec succès
            </span>
          </Col>
        ) : (
          <Col md='3'>
            <Button
              className='text-uppercase text-white bg-secondary border-0'
              onClick={handleSave}
            >
              Sauvegarder
            </Button>
          </Col>
        )}
      </Row>
    </Form>
  );
};



// WEBPACK FOOTER //
// ./src/components/Profile/PasswordEdition.tsx